<template>
    <div class="a-modal">
        <div class="popup__header popup__content--border-bot">
            <h3 class="title title--w550 title--sm popup__title" v-html="$lang('AdminPromoCodeAdd.title')"></h3>
        </div>

        <div class="popup__content">
            <form class="a-modal__add-form form" @submit.prevent="submit">
                <div class="form__item">
                    <div class="form__label" v-html="$lang('AdminPromoCodeAdd.name')"></div>

                    <el-popover
                        v-model="errors.name.isError"
                        trigger="manual"
                        placement="top"
                        class="add__error-popover--width"
                        popper-class="add__error-popover"
                        :content="errors.name.message"
                    >
                        <el-input
                            slot="reference"
                            class="input input--w580 promo-code__form-add-input"
                            :class="{ 'add__error': errors.name.isErrorPaint }"
                            @focus="clearErrors"
                            :placeholder="$lang('AdminPromoCodeAdd.name.placeholder')"
                            v-model="form.name"
                            maxlength="50"
                            clearable>
                        </el-input>
                    </el-popover>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('AdminPromoCodeAdd.code')"></div>
                    <el-popover
                        v-model="errors.code.isError"
                        trigger="manual"
                        placement="top"
                        class="add__error-popover--width"
                        popper-class="add__error-popover"
                        :content="errors.code.message"
                    >
                        <el-input
                            slot="reference"
                            :class="{ 'add__error': errors.code.isErrorPaint }"
                            @focus="clearErrors"
                            class="input input--w580 promo-code__form-add-input"
                            :placeholder="$lang('AdminPromoCodeAdd.code.placeholder')"
                            v-model="form.code"
                            maxlength="24"
                            clearable
                        />
                    </el-popover>
                </div>

                <div class="form__item">
                    <div class="form__label" v-html="$lang('AdminPromoCodeAdd.utm')"></div>
                    <el-popover
                        v-model="errors.utm.isError"
                        trigger="manual"
                        placement="top"
                        class="add__error-popover--width"
                        popper-class="add__error-popover"
                        :content="errors.utm.message"
                    >
                        <el-input
                            slot="reference"
                            :class="{ 'add__error': errors.utm.isErrorPaint }"
                            @focus="clearErrors"
                            class="input input--w580 promo-code__form-add-input"
                            :placeholder="$lang('AdminPromoCodeAdd.utm.placeholder')"
                            v-model="form.utm"
                            maxlength="20"
                            clearable
                        />
                    </el-popover>
                </div>

                <div class="form__item">
                    <div  slot="reference" class="form__label" v-html="$lang('AdminPromoCodeAdd.dates')"></div>

                    <date-interval
                        v-model="form"
                        keyForStart="date_from"
                        key-for-end="date_to"
                        :errors-notifier="Object.assign({start: errors.date_from, end: errors.date_to})"
                        @input="clearErrors"
                    />
                </div>

                <div class="form__item">
                    <el-popover
                        v-model="errors.selectedProducts.isError"
                        trigger="manual"
                        placement="top"
                        class="add__error-popover--width"
                        popper-class="add__error-popover"
                        :content="errors.selectedProducts.message"
                    >
                        <div slot="reference" class="form__label" v-html="$lang('AdminPromoCodeAdd.products')"></div>
                    </el-popover>

                    <div v-if="form.products.length" class="form__products">
                        <div
                            class="form__product-item"
                            v-for="(product, index) in form.products"
                            :key="index"
                        >
                            <span class="form__product-item-name">{{ product.name }}</span>

                            <div>
                                <el-input
                                    class="input input--w222 input--number"
                                    type="number"
                                    min="1"
                                    :max="product.pivot.currency === '%' ? 100 : 1000000"
                                    :maxlength="product.pivot.currency === '%' ? 3 : 7"
                                    :placeholder="$lang('AdminPromoCodeAdd.sum')"
                                    @input="onInputDiscount(product.pivot.discount, index)"
                                    :readonly="!product.pivot || !product.pivot.currency"
                                    v-model="product.pivot.discount"
                                    clearable
                                />


                                <el-select
                                    class="form__discount-select"
                                    :loading-text="$lang('el-select.loading')"
                                    :noDataText="$lang('el-select.noDataText')"
                                    :noMatchText="$lang('el-select.noMatchText')"
                                    :placeholder="$lang('admin.pages.placeholder2')"
                                    @change="onChangeCurrency(index)"
                                    v-model="product.pivot.currency"
                                >
                                    <el-option id="rub" :label="$lang('AdminPromoCodeAdd.rub')" value="rub"/>
                                    <el-option id="%" label="%" value="%"/>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form__item form__item--big-margin">
                    <div class="form__label" v-html="$lang('AdminPromoCodeAdd.uses')"></div>

                    <el-input
                        type="number"
                        class="input input--w222 input--number"
                        :placeholder="'100'"
                        v-model="form.max_uses"
                        @input="onInputMaxUses($event)"
                        maxlength="7"
                        min="1"
                        max="9999999"
                        clearable
                    />
                </div>

                <div class="form__separator">
                    <div>
                        <el-popover
                            v-model="errors.active.isError"
                            trigger="manual"
                            placement="top"
                            class="add__error-popover--width"
                            popper-class="add__error-popover"
                            :content="errors.active.message"
                        >
                            <el-switch
                                slot="reference"
                                class="switch switch--small switch--w-content"
                                v-model="form.active"
                                :inactive-text="$lang('AdminPromoCodeAdd.active')"
                            />
                        </el-popover>
                    </div>
                </div>

                <div class="form__item form__item--padding-top">
                    <button
                        class="btn btn--big btn--main-bg"
                        type="submit"
                    >
                        {{ form.id ? $lang('AdminPromoCodeAdd.save') : $lang('AdminPromoCodeAdd.create') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import datepicker from "../../../mixins/datepicker";
import {mask} from "vue-the-mask";
import DateInterval from "../../../components/DateInterval";
import errors from "../../../mixins/errors";
import validator from "../../../mixins/validator";
import ApiService from "../../../api/api";
import {mapMutations} from "vuex";

export default {
    name: 'AdminPromoCodesAdd',
    components: { DateInterval },
    mixins: [ datepicker, errors, validator ],
    directives: { mask },
    data() {
        return {
            form: {
                name: null,
                code: null,
                utm: null,
                date_from: null,
                date_to: null,
                products: [],
                max_uses: null,
                active: false
            },
            errors: {
                name: {isError: false, message: ''},
                code: {isError: false, message: ''},
                utm: {isError: false, message: ''},
                date_from: {isError: false, message: ''},
                date_to: {isError: false, message: ''},
                selectedProducts: {isError: false, message: ''},
                active: {isError: false, message: ''},
            },
            rules: {
                name: [{required: true, message: Vue.prototype.$lang('AdminPromoCodeAdd.rule.name')}],
                code: [{required: true, message: Vue.prototype.$lang('AdminPromoCodeAdd.rule.code')}],
                selectedProducts: [{required: true, message: Vue.prototype.$lang('AdminPromoCodeAdd.rule.products')}],
            }
        }
    },
    watch: {
        'form.name': {
            handler(val) {
                this.form.name = this.specialSymbols(val);
            }
        },
        'form.code': {
            handler(val) {
                this.form.code = this.specialSymbols(val);
            }
        },
        'form.utm': {
            handler(val) {
                this.form.utm = val.replace(/[^\w-]/g,'');
            }
        },
    },
    computed: {
        selectedProducts() {
            return this.form.products.filter(p => p.pivot.discount && p.pivot.currency);
        }
    },
    mounted() {
        this.getProducts();
    },
    methods: {
        ...mapMutations('promoCode', [
            'addPromoCode',
            'updatePromoCode'
        ]),
        getProducts() {
            let vm = this;

            ApiService.get('/promo-code-products').then((response) => {
                let products = response.data;

                products.forEach(function(product, index) {
                    return product.pivot = {};
                });

                if (this.$route.params.id) {
                    ApiService.get('/promo-codes/' + this.$route.params.id).then((response) => {
                        let promoCode = response.data;
                        vm.form = Object.assign({}, promoCode);
                        vm.$set(vm.form, 'products', products);
                        promoCode.products.forEach(function(product) {
                           vm.form.products.find((p, index) => p.id === product.id && vm.$set(vm.form.products[index], 'pivot', product.pivot));
                        });
                    });
                } else {
                    vm.$set(vm.form, 'products', products);
                }
            });
        },
        submit() {
            this.validate(() => {
                this.$route.params.id ? this.editPromoCode(this.form) : this.createPromoCode(this.form);
            }, {...this.form, ...{selectedProducts: this.selectedProducts}});
        },
        createPromoCode(form) {
            this.$loading(this.$optionsLoading);

            ApiService.post('/promo-codes', form)
                .then((response) => {
                    this.addPromoCode(response.data);
                    this.$router.push({name: 'promo-codes'});
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        editPromoCode(form) {
            this.$loading(this.$optionsLoading);

            ApiService.update('/promo-codes/' + form.id, form)
                .then((response) => {
                    this.updatePromoCode(response.data);
                    this.$router.push({name: 'promo-codes'});
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        specialSymbols(val) {
            return val.replace(/[^\w\sА-я&$@*%]/g,'');
        },
        onInputDiscount(discount, index) {
            this.clearErrors();
            this.$set(this.form.products[index].pivot, 'discount',  Math.max(0, parseFloat(discount)));
        },
        onInputMaxUses(e) {
            this.form.max_uses = Math.max(0, parseFloat(this.form.max_uses));
        },
        onChangeCurrency(index) {
            this.clearErrors();
            this.$set(this.form.products[index].pivot, 'discount', null);
        }
    }
}
</script>
